import { useContext } from "react";
import { contextTheme } from "../contexts/ProviderTheme";
export default function Top() {
  const { toggleTheme } = useContext(contextTheme);
  
  return (
    <div className="top">
        <span><i className="fas fa-info"></i> Los Pagos en esta tienda demo se manejan exclusivamente en la blockchain <a rel="noreferrer" href="https://academy.binance.com/en/articles/connecting-metamask-to-binance-smart-chain" target="_blank" style={{color:"yellow", display:"inline-block"}}>Testnet Binance Smart Chain</a> (BSC)</span>
        <span>Payments with accepted tokens: BNB - DAI - USDT - BUSD</span>
        <a onClick={toggleTheme} >Dark/Light</a>
    </div>

  );
}
